import React, { Component } from 'react';
import { Link } from "react-router-dom";
import NavbarCert from "./Components/Navigation";
import Banner from "./Components/Banner";
import Layout from "../../Components/Layout";

import StrategyMarkdown from "./Contents/strategy.md";
import StaySecureOnlineMarkdown from "./Contents/staySecureOnline.md";
import StrategyAndTacticsMarkdown from "./Contents/strategyTactics.md";
import DefaultMarkdown from "./Contents/defaultMarkdown.md";

import GraduationCaps from "../../Images/situation.jpg";
import GraduationDay from "../../Images/checkmate.jpg";
import OnlineSecure from "../../Images/cyber-safety.jpg";
import DefaultImg from "../../Images/unit.jpg";
import Markdown from "react-markdown";

const certificateTypes = [
  {
    name: "Strategy and Tactics",
    img: GraduationCaps,
    md: StrategyAndTacticsMarkdown,

  },
  {
    name: "Strategy",
    img: GraduationDay,
    md: StrategyMarkdown,

  },
  {
    name: "Stay Secure Online",
    img: OnlineSecure,
    md: StaySecureOnlineMarkdown,
  }
];


class Body extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    return this.update(this.props.markdownPath)
  }

  update(path) {
    return fetch(path, {
      method: 'get',
      headers: {},
    }).then(response => {
      return response.text()
    }).then(text => {
      this.setState({ [this.props.markdownPath]: text })
    })
  }

  routerLink(props) {
    return (
      props.href.match(/^\//)
      ? <Link to={props.href}>{props.children}</Link>
      : <a href={props.href} target="_blank" rel="noopener noreferrer">{props.children}</a>
    );
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.markdownPath !== this.props.markdownPath) {
      return this.update(this.props.markdownPath);
    }
  }

  render() {
    return (
      <React.Fragment>
      <div className="container text-justify mt-4">
      {
        this.props.markdownPath && <Markdown escapeHtml={false} source={this.state[this.props.markdownPath] || "Loading..."} renderers={{link: this.routerLink}} />
      }
        
      </div>
      { this.props.logos && this.props.logos }
      </React.Fragment>
    )
  }

}

export default class Certificates extends Component {
  render() {
    let name = this.props.match.params.name;
    const { name: certName, img: imgPath, md: markdownPath } = certificateTypes.find(certs => name === certs.name.replace(/\s/g, '').toLowerCase()) || {
      name: "",
      img: DefaultImg,
      md: DefaultMarkdown,
    };
    const isCertificate = true;

    return (
      <div className="App">
        <Layout
          head={<React.Fragment><NavbarCert /></React.Fragment>}
          body={
            <React.Fragment>
              <Banner certName={certName} imgPath={imgPath} isCertificate={isCertificate} />
              <Body name={name} markdownPath={markdownPath} />
            </React.Fragment>}
        />
      </div>);
  }
}

export { Body }



// WEBPACK FOOTER //
// ./src/Pages/Certificates/index.js